import { FieldUpdateHandlerParam } from 'shared/form';
// eslint-disable-next-line import/prefer-default-export
export function useAlarmNotificationProfileFieldCreateNew(
  handleFieldUpdate: (param: FieldUpdateHandlerParam) => void,
): [(param: FieldUpdateHandlerParam) => void] {
  const handleFieldCreateNew: (param: FieldUpdateHandlerParam) => void = (param) => {
    const { name } = param;

  };

  return [handleFieldCreateNew];
}
